import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"

export default class extends Controller {

  static values = { url: String }

  static targets = ["urlInput", "timestampInput", "copyButton", "timestampToggle"]

  initialize() {
    Loggable(this, { debug: true })
  }

  connect() {
    this.refreshUrl()
    this.initClipboard()
    this.log("connected")
  }

  refreshUrl(){
    if(this.timestampToggleTarget.checked){
      let newUrl = this.urlValue + "?ts=" + this.timestampInputTarget.value
      this.urlInputTarget.value = newUrl
      this.copyButtonTarget.dataset.clipboardText = newUrl
    } else {
      this.urlInputTarget.value = this.urlValue
      this.copyButtonTarget.dataset.clipboardText = this.urlValue
    }
  }

  // clipboardJS is not working in Safari, so we use the native Clipboard API
  initClipboard() {
    // Bind only once
    if (this.boundCopyHandler) return
    if (!this.hasCopyButtonTarget) return

    this.boundCopyHandler = this.copyToClipboard.bind(this)
    this.copyButtonTarget.addEventListener("click", this.boundCopyHandler)
  }

  copyToClipboard(e) {
    const trigger = e?.currentTarget || (this.hasCopyButtonTarget ? this.copyButtonTarget : null)
    if (!trigger) return

    const text = trigger.dataset.clipboardText
    const copiedMsg = trigger.dataset.copiedMsg
    if (!text) return

    // Prefer the modern async Clipboard API
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text)
        .then(() => {
          this.log("copied", text)
          if (copiedMsg) alert(copiedMsg)
        })
        .catch(() => this.fallbackCopy(text, copiedMsg))
    } else {
      // Fallback for older‑but‑still‑modern browsers
      this.fallbackCopy(text, copiedMsg)
    }
  }

  fallbackCopy(text, copiedMsg) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "absolute"
    textarea.style.left = "-9999px"
    document.body.appendChild(textarea)
    textarea.select()
    try {
      document.execCommand("copy")
      if (copiedMsg) alert(copiedMsg)
    } finally {
      document.body.removeChild(textarea)
    }
  }

  disconnect() {
    if (!this.boundCopyHandler) return

    if (this.hasCopyButtonTarget) {
      this.copyButtonTarget.removeEventListener("click", this.boundCopyHandler)
    }

    this.boundCopyHandler = null
  }

}
